import { AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { DocumentService } from '../../core/services/document.service';
import { selectConfigurationRequestsMaxFileSize } from '../../core/selectors/config.selectors';
import { AppState } from '../../core/reducers';

@Injectable({
    providedIn: 'root'
})
export class AttachmentValidator {

    requestsMaxFileSize: number;

    constructor(private store: Store<AppState>,
                private documentService: DocumentService) {
        this.store.select(selectConfigurationRequestsMaxFileSize)
            .pipe(take(1))
            .subscribe(size => this.requestsMaxFileSize = size);
    }

    createValidator(): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | undefined> => {

            const value = control.value;

            if (!value || !(value instanceof File)) {
                return of(undefined);
            }

            if (value.size > this.requestsMaxFileSize) {
                return of({'max_file_size': true});
            }

            return this.documentService.checkForPdfOrDocxProtection(value)
                .pipe(catchError(error => {
                    if (error.status === 412 && error.error && error.error.length > 0) {
                        const {second} = error.error[0];
                        const errorKey = second.includes('PROTECTED') ? 'protected' :
                            second.includes('EXTENTION') ? 'embedded_extension' :
                                'error';

                        return of({[errorKey]: true});
                    }
                    return of(undefined);
                }));
        };
    }
}
